'use client';

import { Button } from '@/components/ui/button';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { useState } from 'react';
import { useUserInfo } from '@/provider/UserInfoProvider';
import useInvite from '../../invite/hooks/useInvite';

export default function Share({ className = '' }: { className?: string }) {
  const title = '🚀 Try Kaze.ai and Get 3 Free Credits!';
  const { handleInvite, inviteIsPending, inviteUrl } = useInvite({
    onSuccess: (data) => {
      const url = `${window.location.origin}/invite?invite_code=${data!.invite_code}&utm_source=referal&utm_medium=referal&utm_campaign=referal&utm_content=${data!.invite_code}`;
      const text = `
      Hey! I’ve been using Kaze.ai for smart photo editing — it’s fast and super fun.
      👉 Sign up and try any tool you like (like watermark removal, restoration, or expansion). You’ll get 3 free credits to start!
      🔗 ${url}
      Let’s make photo editing easy and creative! 🙌`;
      const xText = `
      👉 Sign up and try any tool you like (like watermark removal, restoration, or expansion). You’ll get 3 free credits to start!
      🔗 ${url}
      Let’s make photo editing easy and creative! 🙌`;
      setShareUrl(url);
      setDescription(text);
      setXDescription(xText);
      setOpen(true);
    },
    isCopyUrl: false,
  });
  const { userIdentity } = useUserInfo();
  const isLoginUser = userIdentity === 3;
  const [shareUrl, setShareUrl] = useState('');
  const [description, setDescription] = useState('');
  const [xDescription, setXDescription] = useState('');
  const [open, setOpen] = useState(false);

  return (
    <Drawer
      open={open}
      onOpenChange={(e) => {
        if (!inviteUrl) return;
        setOpen(e);
      }}
    >
      <DrawerTrigger asChild>
        <Button
          onClick={(e) => {
            !isLoginUser && e.preventDefault();
            if (inviteUrl) return;
            handleInvite();
          }}
          className={`h-11 rounded-[0.375rem] bg-gray-800 text-base font-medium text-stone-50 ${inviteIsPending ? 'pointer-events-none' : 'pointer-events-auto'} ${className}`}
        >
          Share
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className='text-center leading-normal'>
            🚀 Share your link with your friends and get 25% off! 🎉
          </DrawerTitle>
        </DrawerHeader>
        <DrawerDescription />
        <div className='mt-4 flex flex-row justify-evenly pb-20'>
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon size={48} round />
          </FacebookShareButton>
          <TwitterShareButton url={xDescription} title={title}>
            <XIcon size={48} round />
          </TwitterShareButton>
          <WhatsappShareButton url={description} title={title} separator=':: '>
            <WhatsappIcon size={48} round />
          </WhatsappShareButton>
          <EmailShareButton url={description} subject={title}>
            <EmailIcon size={48} round />
          </EmailShareButton>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
